import { withContext } from '../Context'
import TestScoreSelectorWithSubjects, { Subject } from './TestScoreSelectorWithSubjects'

const ACT_SUBJECTS: Subject[] = [
  { name: 'ACTMath', label: 'Math', min: 1, max: 36, rangeStep: 1 },
  { name: 'ACTReading', label: 'Reading', min: 1, max: 36, rangeStep: 1 },
  { name: 'ACTScience', label: 'Science', min: 1, max: 36, rangeStep: 1 },
  { name: 'ACTEnglish', label: 'English', min: 1, max: 36, rangeStep: 1 },
]

type ACTScoreSelectorProps = {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
  segment: object
  isSubjectTestsEnabled?: boolean
}

export const ACTScoreSelector = (props: ACTScoreSelectorProps) => {
  return (
    <TestScoreSelectorWithSubjects
      {...props}
      testLabel="ACT"
      totalScoreSegmentName="ACT"
      totalScoreMin={1}
      totalScoreMax={36}
      totalScoreStep={1}
      subjects={ACT_SUBJECTS}
    />
  )
}

export default withContext(ACTScoreSelector)
